// ============================================
// APPLICATION - Heartbeat Hook
// ============================================

import { useEffect } from 'react';
import { sessionRepository } from '../../infrastructure/http/session.repository';
import { useAuthStore } from '../../state/auth.store';

const HEARTBEAT_KEY = 'almacenes_last_heartbeat';
const ONE_DAY_MS = 24 * 60 * 60 * 1000;

/**
 * Hook para enviar heartbeat una vez al día
 * Registra la actividad del usuario en el backend
 * Solo se ejecuta para usuarios autenticados
 */
export const useHeartbeat = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) return;

    const sendHeartbeatIfNeeded = async () => {
      const lastHeartbeat = localStorage.getItem(HEARTBEAT_KEY);
      const now = Date.now();

      // Si no hay registro o pasó más de 24h
      if (!lastHeartbeat || now - parseInt(lastHeartbeat) >= ONE_DAY_MS) {
        try {
          await sessionRepository.sendHeartbeat();
          localStorage.setItem(HEARTBEAT_KEY, now.toString());
          console.log('[Heartbeat] Enviado exitosamente');
        } catch (error) {
          console.error('[Heartbeat] Error al enviar:', error);
          // No bloquear la app si falla
        }
      } else {
        const hoursRemaining = Math.floor((ONE_DAY_MS - (now - parseInt(lastHeartbeat))) / (60 * 60 * 1000));
        console.log(`[Heartbeat] Ya enviado hoy. Próximo en ~${hoursRemaining}h`);
      }
    };

    // Enviar inmediatamente si es necesario
    sendHeartbeatIfNeeded();

    // Verificar cada hora si ya pasaron 24h
    const interval = setInterval(sendHeartbeatIfNeeded, 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, [isAuthenticated]);
};
